import type { SVGProps } from 'react';

export const Dash = (props: SVGProps<any>) => (
  <svg
    height="512px"
    role="img"
    version="1.1"
    viewBox="0 0 512 512"
    width="512px"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <title>{'dash-icon'}</title>
    <g transform="scale(1,-1) translate(0 -512)">
      <path d="M128 288l0-64 256 0 0 64z" fill={props.fill} />
    </g>
  </svg>
);
